module.exports = __webpack_public_path__ + "static/media/31.5c5a8917.mp3";